import * as React from "react"

const Plus = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M7.5 8.5v3h1v-3h3v-1h-3v-3h-1v3h-3v1h3Z" />
  </svg>
)

export default Plus
